import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { WeekViewEvent } from 'calendar-utils';


export class CalendarWeekViewEventComponent {

   weekEvent: WeekViewEvent;

   tooltipPlacement: string;

   eventClicked: EventEmitter<any> = new EventEmitter();

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mwl-calendar-week-view-event',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="cal-event"
      [class.cal-starts-within-week]="!weekEvent.startsBeforeWeek"
      [class.cal-ends-within-week]="!weekEvent.endsAfterWeek"
      [style.backgroundColor]="weekEvent.event.color.secondary"
      [ngClass]="weekEvent.event?.cssClass"
      [mwlCalendarTooltip]="weekEvent.event | calendarEventTitle:'weekTooltip'"
      [tooltipPlacement]="tooltipPlacement">
      <mwl-calendar-event-title
        [event]="weekEvent.event"
        view="week"
        (click)="eventClicked.emit()">
      </mwl-calendar-event-title>
    </div>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'weekEvent': [{ type: Input },],
'tooltipPlacement': [{ type: Input },],
'eventClicked': [{ type: Output },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
